import { connect } from "react-redux";
import get from "lodash/get";

import { getListSensors as onGetListSensors } from "./../../actions/listSensorsActions";

const mapStateToProps = (state) => ({
  listSensorsDataState: state.listSensors.dataState,
  listSensors: get(state, ["listSensors", "listSensors"], { sensors: [] }),
});

const mapDispatchToProps = {
  onGetListSensors,
};

const withListSensors = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withListSensors };
